<script lang="ts" module>
  let globalError = $state(false);
  export const setGlobalError = () => {
    globalError = true;
  };
</script>

<script lang="ts">
  import Modal from '@athena-lib/Modal/Modal.svelte';
  import Banner from '@athena-lib/Banner/Banner.svelte';
  import { Error } from '@athena-lib/Icons';
  import { Text } from '@athena-lib/Text';
  import { Button, ButtonLink } from '@athena-lib/Button';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import type { ExpandedCheckoutSettings } from '$lib/server/expanders/checkoutSettingsExpander';
  const {
    errorTitle,
    errorDescription,
    errorButtonText,
    errorButtonLink,
  }: ExpandedCheckoutSettings = $props();
  const translations = getCommonTranslations();
</script>

<Modal
  size="sm"
  showModal={globalError}
  onClose={() => {
    globalError = false;
  }}
>
  <Banner title={errorTitle ?? translations.anErrorHasOccured} variant="error">
    {#snippet icon()}
      <Error sizeClass="size-6" />
    {/snippet}
    {#snippet content()}
      <div class="flex flex-col gap-4">
        {#if errorDescription}
          <Text element="p" size="xsmall" color="dark-red">
            {errorDescription}
          </Text>
        {/if}
        <div class="flex justify-end gap-2">
          <Button
            color="dark"
            onClick={() => {
              globalError = false;
            }}>{translations.cancel}</Button
          >
          {#if errorButtonLink && errorButtonText}
            <ButtonLink link={{ href: errorButtonLink }} data-initialfocus="true" color="brand"
              >{errorButtonText}</ButtonLink
            >
          {/if}
        </div>
      </div>
    {/snippet}
  </Banner>
</Modal>
